import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';
import { useState } from 'react';
import * as React from 'react';

import { trackCloseOfferComplain, trackOpenOfferComplain } from './tracking';
import { useOfferContext } from '../../../../context';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';
import { ComplaintModal } from 'shared/components/OfferCard/Complaint/ComplaintModal';
import { BlockErrorBoundary } from 'shared/containers/BlockErrorBoundary';

interface IProps {
  isHovered: boolean;
}

export const ComplainControlContainer = ({ isHovered }: IProps) => {
  const [open, setOpen] = useState(false);

  const { offer, position } = useOfferContext();

  const handleOpen = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setOpen(true);
      trackOpenOfferComplain(offer.id ?? undefined, position);
    },
    [offer.id, position],
  );

  const handleClose = React.useCallback(() => {
    setOpen(false);
    trackCloseOfferComplain(offer.id ?? undefined, position);
  }, [offer.id, position]);

  return (
    <>
      <ControlWrapper visible={isHovered}>
        <TooltipDesktop theme="black" placement="left" title="Пожаловаться">
          <Button
            data-mark="ComplainControl"
            theme="stroke_secondary"
            onClick={handleOpen}
            size="XS"
            beforeIcon={<IconFunctionalWarningSign16 />}
          />
        </TooltipDesktop>
      </ControlWrapper>
      <BlockErrorBoundary>
        <ComplaintModal offer={offer} onCloseModal={handleClose} openModal={open} />
      </BlockErrorBoundary>
    </>
  );
};
